module.exports = __webpack_public_path__ + "static/media/horoscope-icon-10.72cf78b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-10.png
// module id = 1526
// module chunks = 0